import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { CreateAmountDto } from '../types';

export const useCreateInfrastructureCostAmount = () =>
  useMutation<void, unknown, CreateAmountDto>((createAmountDto) =>
    infrastructuresRepo.createInfrastructureCostAmount(createAmountDto),
  );
